import { z } from "zod";
import { zCorpCompanyStatus } from "@/types/corp/corpSession.common";
import { zCreditState } from "./company.common";
export const zBankDetailsDom = z.object({
    bankName: z.string().nullable(),
    bik: z.string().nullable(),
    account: z.string().nullable(),
    corrAccount: z.string().nullable(),
});
/**
 * Реквизиты компании — всё, что правят обе роли персонала (P-2, P-3).
 * Ключи совпадают с ключами payload `corp_company_create` / `corp_company_update` (§4.3).
 */
export const zCompanyRequisitesDom = z.object({
    name: z.string().min(1),
    legalName: z.string().nullable(),
    inn: z.string().nullable(),
    kpp: z.string().nullable(),
    ogrn: z.string().nullable(),
    legalAddress: z.string().nullable(),
    bankDetails: zBankDetailsDom.nullable(),
    contactName: z.string().nullable(),
    contactPhone: z.string().nullable(),
    contactEmail: z.string().nullable(),
    contractNumber: z.string().nullable(),
    contractDate: z.string().nullable(),
    comment: z.string().nullable(),
});
export const zCorpCompanyDom = zCompanyRequisitesDom.extend({
    id: z.string(),
    status: zCorpCompanyStatus,
    statusReason: z.string().nullable(),
    statusChangedAt: z.string().nullable(),
    creditState: zCreditState,
    activeLinksCount: z.number(),
    adminsCount: z.number(),
    openOrdersCount: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
